<template>
    <div id="upload-content-section" class="d-flex">
        <span>Adicione fotos para ilustrar sua avaliação:</span>
        <div
            class="file-uploader d-flex"
            @dragover.prevent
            @dragenter="isDragging = true"
            @dragleave="isDragging = false"
            @drop="handleFileDrop"
            @click="handleFileInputClick"
        >
            <i class="icon-cr icon-photo" />
            <span>{{
                isDragging
                    ? 'Solte os arquivos aqui'
                    : 'Clique aqui ou arraste suas imagens para adicioná-las à sua avaliação'
            }}</span>
            <input
                type="file"
                ref="fileInput"
                @change="handleFileUpload"
                multiple
                style="display: none"
            />
        </div>
        <div id="upload-thumbnails" v-if="thumbnails.length > 0">
            <div v-for="(thumbnail, index) in thumbnails" :key="index" class="thumbnail">
                <img :src="thumbnail" />
            </div>
        </div>
        <!-- <div class="example-btn">
            <file-upload
                class="btn btn-primary"
                post-action="/upload/post"
                :multiple="true"
                :drop="true"
                :drop-directory="true"
                v-model="files"
                ref="upload"
            >
                <i class="fa fa-plus"></i>
                Select files
            </file-upload>
            <button
                type="button"
                class="btn btn-success"
                v-if="!$refs.upload || !$refs.upload.active"
                @click.prevent="$refs.upload.active = true"
            >
                <i class="fa fa-arrow-up" aria-hidden="true"></i>
                Start Upload
            </button>
            <button
                type="button"
                class="btn btn-danger"
                v-else
                @click.prevent="$refs.upload.active = false"
            >
                <i class="fa fa-stop" aria-hidden="true"></i>
                Stop Upload
            </button>
        </div> -->

        <span class="rules-btn text-underline" @click="openRulesUpload = true">Ver regras</span>
        <Modal v-model="openRulesUpload" class="small">
            <div class="rules-modal d-flex">
                <div class="rules-modal-header d-flex">
                    <i class="icon-cr icon-logo-header-cr" />
                    <div class="v-divider" />
                    <span class="logo-text">Painel de Avaliações</span>
                </div>
                <div class="rules-modal-content d-flex">
                    <span class="rules-modal-title text-center">Regras para o envio de fotos:</span>
                    <div class="rules-modal-text">
                        <ul>
                            <li>Serão aceitos apenas arquivos nos formatos JPG, JPEG ou PNG;</li>
                            <li>As imagens devem ter até 15MB de tamanho;</li>
                            <li>Você pode adicionar até 5 fotos por avaliação;</li>
                            <li>
                                Você não deve adicionar fotos que exponham sua identidade ou de
                                terceiros;
                            </li>
                            <li>
                                Você não deve adicionar fotos de crianças ou adolescentes (menores
                                de 18 anos)
                            </li>
                        </ul>
                        <p>
                            Nos nós reservamos no direito de excluir avaliações que descumpram essas
                            regras.
                        </p>
                    </div>
                </div>
                <button class="btn btn-close-modal bg-default-5" @click="openRulesUpload = false">
                    Fechar
                </button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import Modal from '../../common/container/Modal.vue';

    export default {
        name: 'UploadMediaSection',
        components: { Modal },

        data() {
            return {
                openRulesUpload: false,
                isDragging: false,
                thumbnails: [],
                fileList: [],
            };
        },
        methods: {
            addFiles(files) {
                const newFiles = [];
                for (let i = 0; i < files.length; i++) {
                    const file = files[i];
                    if (!this.isDuplicate(file)) {
                        newFiles.push(file);
                    }
                }
                const allFiles = this.mergeFileLists(this.fileList, newFiles);
                this.fileList = allFiles;
                this.createThumbnails(this.fileList);
                this.updateUpload();
            },

            handleFileUpload(event) {
                const files = event.target.files;
                this.addFiles(files);
            },

            handleFileDrop(event) {
                event.preventDefault();
                const files = event.dataTransfer.files;
                this.addFiles(files);
                this.isDragging = false;
            },

            handleFileInputClick() {
                this.$refs.fileInput.click();
            },

            createThumbnails(files) {
                this.thumbnails = [];
                for (let i = 0; i < files.length; i++) {
                    const file = files[i];
                    this.createThumbnail(file);
                }
            },

            createThumbnail(file) {
                const reader = new FileReader();
                reader.onload = (event) => {
                    const thumbnail = event.target.result;
                    this.thumbnails.push(thumbnail);
                };
                reader.readAsDataURL(file);
            },

            mergeFileLists(fileList1, fileList2) {
                const blobArray = [];
                for (let i = 0; i < fileList1.length; i++) {
                    blobArray.push(fileList1[i]);
                }
                for (let i = 0; i < fileList2.length; i++) {
                    blobArray.push(fileList2[i]);
                }
                const dataTransfer = new DataTransfer();
                for (let i = 0; i < blobArray.length; i++) {
                    dataTransfer.items.add(blobArray[i]);
                }
                return dataTransfer.files;
            },

            isDuplicate(newFile) {
                for (let i = 0; i < this.fileList.length; i++) {
                    const file = this.fileList[i];
                    if (newFile.name === file.name && newFile.size === file.size) {
                        return true;
                    }
                }
                return false;
            },

            updateUpload() {
                this.$emit('update-form', { field: 'upload', value: this.fileList });
            },
        },
    };
</script>
